import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './_components/_auth/login/login.component';
import { RegistrationFormComponent } from './_components/_registration/registration-form/registration-form.component';
import { AuthAttendeeGuard } from './_helpers/authAttendee.guard';
import { ReceptionComponent } from './_components/_reception/reception/reception.component';
import { CheckRequirementsComponent } from './_components/_techcheck/check-requirements/check-requirements.component';
import { SchedulerComponent } from './_components/_registration/scheduler/scheduler.component';
import { RegistrationSuccessComponent } from './_components/_registration/registration-success/registration-success.component';
import { BoothOverviewComponent } from './_components/_tradefair/booth-overview/booth-overview.component';
import { DvgwErrorPageLoginComponent } from './_components/_auth/dvgw-error-page-login/dvgw-error-page-login.component';
import { ResetPasswordComponent } from './_components/_auth/reset-password/reset-password.component';
import { LandingpageComponent } from './_components/landingpage/landingpage.component';
import { customApp } from './_configuration/configuration';
import { IEventGeneralSettings } from '@sv/interfaces';

const routes: Routes = [
  { path: '', component: ReceptionComponent, canActivate: [AuthAttendeeGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'login/error', component: DvgwErrorPageLoginComponent },
  { path: 'reset', component: ResetPasswordComponent },
  { path: 'av63wraph3bdva3r8', component: LoginComponent },
  { path: 'check', component: CheckRequirementsComponent },
  { path: 'booth/:id', component: BoothOverviewComponent },
  {
    path: 'register',
    children: [
      { path: '', component: RegistrationFormComponent },
      { path: 'schedule', component: SchedulerComponent },
      { path: 'success', component: RegistrationSuccessComponent }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthAttendeeGuard]
})
export class AppRoutingModule {
  private initalRoutes: Routes = [
    { path: '', component: ReceptionComponent, canActivate: [AuthAttendeeGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'login/error', component: DvgwErrorPageLoginComponent },
    { path: 'reset', component: ResetPasswordComponent },
    { path: 'av63wraph3bdva3r8', component: LoginComponent },
    { path: 'check', component: CheckRequirementsComponent },
    { path: 'booth/:id', component: BoothOverviewComponent },
    {
      path: 'register',
      children: [
        { path: '', component: RegistrationFormComponent },
        { path: 'schedule', component: SchedulerComponent },
        { path: 'success', component: RegistrationSuccessComponent }
      ]
    },
    { path: '**', redirectTo: '' }
  ];
  getInitalRoutes() {
    if ((customApp.generalSettings as IEventGeneralSettings).enableLP) {
      this.initalRoutes[0] = { path: '', component: LandingpageComponent };
    }

    return this.initalRoutes;
  }
}
